{
  "id": "campaign-103",
  "name": "Elegant Terrace",
  "seed": "campaign:103",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".....ACCA.....",
    ".t.t..CC..t.t.",
    ".....,CC......",
    "wwwwww++wwwwww",
    ".....,CC......",
    ".x...CCCC...x.",
    "...t.CwwC.t...",
    ".....CwwC.....",
    "....hCwwCh....",
    "%%...CCCC..~%%",
    "%..t..CC..t..%",
    "~~~..tCCt..~..",
    ".~X...CC...X..",
    "..............",
    "S............."
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 11,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 14
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 11
    },
    {
      "kind": "repair",
      "x": 0,
      "y": 0
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "falls": [
    {
      "x": 2,
      "y": 12,
      "dir": "E",
      "at": 29,
      "length": 3
    },
    {
      "x": 11,
      "y": 12,
      "dir": "W",
      "at": 35,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 103,
  "biome": "estate",
  "par": {
    "reel": 5671,
    "push": 5123,
    "selfPropelled": 4560,
    "tractor": 4030,
    "zeroTurn": 3276,
    "fairway": 2927
  },
  "goldTime": {
    "reel": 5671,
    "push": 5123,
    "selfPropelled": 4560,
    "tractor": 3790,
    "zeroTurn": 3276,
    "fairway": 2707
  },
  "routeTries": {
    "par": {
      "reel": 5,
      "push": 24,
      "selfPropelled": 21,
      "tractor": 18,
      "zeroTurn": 13,
      "fairway": 21
    },
    "gold": {
      "reel": 5,
      "push": 24,
      "selfPropelled": 21,
      "tractor": 41,
      "zeroTurn": 13,
      "fairway": 36
    }
  }
}
